import { collapseAccordionItem, expandAccordionItem } from './AccordionHelper';

interface AccordionProps {
    el: HTMLDivElement;
}

const Accordion = ({ el }: AccordionProps): void => {
    const ITEM_CLASS = '.accordion-item';

    const accordionItems = el.querySelectorAll<HTMLElement>(ITEM_CLASS);

    const hasItems = accordionItems.length > 0;

    if (hasItems) {
        // Get hash from URL
        const { hash } = window.location;

        accordionItems.forEach(item => {
            const triggerEl: HTMLButtonElement | null = item.querySelector('.accordion-heading button');
            const collapsibleEl: HTMLDivElement | null = item.querySelector(`.accordion-content`);

            if (!triggerEl || !collapsibleEl) {
                return;
            }

            const itemDefaultToOpen = item.classList.contains('is-open');

            const itemId = item.getAttribute('id') || '';
            const isHashMatch = hash && hash === `#${itemId}`;

            if (isHashMatch || itemDefaultToOpen) {
                // If the hash matches the item ID OR the item is set to open by default,
                // open the accordion item
                expandAccordionItem(collapsibleEl, () => {
                    item.classList.add('is-open');
                    triggerEl.setAttribute('aria-expanded', 'true');
                });
            } else {
                // on default, close all accordion items
                // and set the height so we can animate it later
                collapseAccordionItem(collapsibleEl, () => {
                    item.classList.remove('is-open');
                    triggerEl.setAttribute('aria-expanded', 'false');
                });
            }

            triggerEl.addEventListener('click', () => {
                const isOpen = item.classList.contains('is-open');

                if (isOpen) {
                    collapseAccordionItem(collapsibleEl, () => {
                        item.classList.remove('is-open');
                        triggerEl.setAttribute('aria-expanded', 'false');
                    });
                } else {
                    expandAccordionItem(collapsibleEl, () => {
                        item.classList.add('is-open');
                        triggerEl.setAttribute('aria-expanded', 'true');
                    });
                }
            });
        });
    }
};

export default Accordion;
